import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  href?: string;
  external?: boolean;
}
export const CHECKOUT_URL = 'https://checkout.ebookpoint.shop/cart/59481985744977:1';
export function Button({
  children,
  variant = 'primary',
  className = '',
  href,
  external,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 ease-in-out shadow-sm hover:shadow-lg active:scale-95';
  const variants = {
    primary: 'bg-brand-green text-brand-dark hover:bg-brand-green-dark',
    secondary: 'bg-white text-brand-dark border border-slate-200 hover:bg-slate-50'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;
  if (href) {
    const isExternal = external || href.startsWith('http');
    return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={combinedClassName} data-id="element-158">
        {children}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-159">
      {children}
    </button>;
}